import {computed} from 'vue';
import {usePermissionsService} from '@/composables/usePermissionsService';
import {usePhysiciansStore} from '@/stores/physicians';
import {usePatientsStore} from "@/stores/patients";

export function usePatientsGridVisibility() {
  const permissions = usePermissionsService();
  const physiciansStore = usePhysiciansStore();
  const patientsStore = usePatientsStore();

  const isSearchingByPhysician = computed(() => {
    const physician = physiciansStore.getPhysician;
    return physician?.userId !== "" && physician?.userId !== null;
  });

  const isSearchingByCegatId = computed(() => {
    return patientsStore.getSearchCegatId
  });

  const showPatientsGrid = computed(() => {
    if (permissions.hasPatientReadAllPermission) {
      return isSearchingByCegatId.value || isSearchingByPhysician.value
    }
    return permissions.hasPatientReadPermission;
  });

  const showInternalToolbar = computed(() => {
    return permissions.hasPatientReadAllPermission || permissions.hasPatientReadCountryPermission;
  });

  return {
    isSearchingByPhysician,
    showPatientsGrid,
    showInternalToolbar,
    isSearchingByCegatId,
  };
}
